import { render, staticRenderFns } from "./CardPropertyAddress.vue?vue&type=template&id=7184d7e1&scoped=true&"
import script from "./CardPropertyAddress.vue?vue&type=script&lang=js&"
export * from "./CardPropertyAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7184d7e1",
  null
  
)

export default component.exports